import { useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useSearchBar } from "hooks/useSearchBar.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import { usePicker } from "contexts/pickerContext/pickerContext.ts";

const SearchBar = () => {
  const { getTextByKey } = useContent();

  const {
    handleSubmit,
    handleChange,
    setShowSearchInList,
    searchIn,
    setSearchIn,
    searchValue,
    setSearchValue,
  } = useSearchBar();
  const { setSearchTerm: setSearchPickerTerm } = usePicker();
  const [selectedCategory, setSelectedCategory] = useState(searchIn);

  const handleApply = () => {
    setSearchIn(selectedCategory);
    setShowSearchInList(false);
  };

  const handleClearAll = () => {
    // setSearchIn("all");
    // setSelectedCategory("all");
    setShowSearchInList(false);
  };

  return (
    <>
      <div className="search-bar">
        {/* <div className="search-in" ref={ref}> */}
          {/* <Icon
            name="settings-sliders"
            gray
            onClick={() => {
              setShowSearchInList((prev) => !prev);
            }}
            iconClass={`settings-icon ${
              getQueryParam("t") === "picker" ? "settings-icon-disabled" : ""
            }`}
          /> */}
          {/* <CustomPopup showState={showSearchInList} topPosition={48}>
            <div className="checkbox-list-dropdown">
              <Icon
                name="x"
                iconClass="close-icon"
                onClick={() => setShowSearchInList(false)}
              />
              <h1>{getTextByKey("advanced-search")}</h1>
              <hr />
              <h2>{getTextByKey("search-by-category")}</h2>
              <ul>
                {Object.keys(searchInObj).map((item) => {
                  return (
                    <li onClick={() => setSelectedCategory(item)} key={item}>
                      <div
                        className={`checkbox-wrapper ${
                          selectedCategory === item ? "selected" : ""
                        }`}
                      >
                        {selectedCategory === item && (
                          <Icon
                            name="newInbox/mark"
                            iconClass="mark-icon"
                            blue
                          />
                        )}
                      </div>
                      {getTextByKey(searchInObj[item])}
                    </li>
                  );
                })}
              </ul>
              <div className="buttons">
                <Button onClick={handleApply}>
                  {getTextByKey("search-apply")}
                </Button>
                <button className="clear-button" onClick={handleClearAll}>
                  {getTextByKey("search-clear-all")}
                </button>
              </div>
            </div>
          </CustomPopup> */}
        {/* </div> */}
        <form onSubmit={handleSubmit}>
          <input
            type=""
            value={searchValue}
            onChange={handleChange}
            placeholder={getTextByKey("search-button-tooltip")}
          />
        </form>
        <div className="divider"/>
        <div className="search-submit" onClick={handleSubmit}>
          <Tooltip
            id={"searchSubmit"}
            tooltipTextKey={"search-button-tooltip"}
            bottom
          >
            <Icon name="search" gray />
          </Tooltip>
        </div>
      </div>
      {searchValue?.length > 0 ? (
        <div
          className="clear-button"
          onClick={(e) => {
            setSearchPickerTerm("");
            setSearchValue("");
            handleSubmit(e, "clear");
          }}
        >
          <Tooltip
            id={"searchClear"}
            tooltipTextKey={"clear-search-button-tooltip"}
            bottom
          >
            <Icon name="x" blue />
          </Tooltip>
        </div>
      ) : null}
    </>
  );
};

export default SearchBar;
